import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
  output,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { LucideAngularModule, X, FileText } from 'lucide-angular';

/**
 * Generic preview item interface that works for both PendingAttachment and Resource
 */
export interface PreviewItem {
  /** Image/resource URL to display */
  url: string;
  /** File name to display */
  fileName: string;
  /** MIME type for determining preview type */
  mimeType: string;
}

@Component({
  selector: 'app-image-preview-modal',
  standalone: true,
  imports: [CommonModule, LucideAngularModule],
  templateUrl: './image-preview-modal.component.html',
  styleUrl: './image-preview-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ImagePreviewModalComponent {
  private readonly sanitizer = inject(DomSanitizer);

  readonly previewItem = input<PreviewItem | null>(null);

  readonly closed = output<void>();

  protected readonly icons = {
    X,
    FileText,
  };

  /** Sanitized URL for PDF object embed */
  protected readonly safePdfUrl = computed<SafeResourceUrl | null>(() => {
    const item = this.previewItem();
    if (item && this.isPdf(item.mimeType)) {
      return this.sanitizer.bypassSecurityTrustResourceUrl(item.url);
    }
    return null;
  });

  protected closePreview(): void {
    this.closed.emit();
  }

  protected isPdf(mimeType: string): boolean {
    return mimeType === 'application/pdf';
  }

  protected onBackdropClick(): void {
    this.closePreview();
  }

  protected onContentClick(event: Event): void {
    event.stopPropagation();
  }
}
